import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.querySelectorAll('.legal-heading').forEach(heading => {
      const id = heading.getAttribute('id')
      if (id) {
        if (heading.querySelector('.link-icon')) return;

        const linkIcon = document.createElement('a');
        linkIcon.href = '#' + id;
        linkIcon.className = 'link-icon';
        linkIcon.innerHTML = '<i class="bi bi-link-45deg"></i>';
        linkIcon.setAttribute('aria-label', 'Link to this section');

        linkIcon.addEventListener('click', function(e) {
          e.preventDefault();
          const url = window.location.origin + window.location.pathname + '#' + id;
          navigator.clipboard.writeText(url).then(function() {
            history.pushState(null, null, '#' + id);
            const originalIcon = linkIcon.innerHTML;
            linkIcon.innerHTML = '<i class="bi bi-check"></i>';
            setTimeout(function() {
              linkIcon.innerHTML = originalIcon;
            }, 1000);
          });
        });

        heading.insertBefore(linkIcon, heading.firstChild);
      }
    });
  }
}
